import { Box, Flex, Heading, Image } from "@chakra-ui/react";
import {
  itineraryApi,
  ItineratorItineraryList,
  ItineratorSimpleItinerary,
} from "itinerator-api";
import { useEffect } from "react";
import { useState } from "react";
import { RoadTripLink } from "~/components/Buttons";
import { Subheading } from "~/components/Text";
import { useNavbarHeight } from "~/lib/hooks";
import { Polaroid } from "../Polaroid";

type PropsFourthPanel = {
  itineraries: ItineratorItineraryList;
};
export const FourthPanel = ({ itineraries }: PropsFourthPanel) => {
  const [roadtrips, setRoadtrips] = useState<ItineratorItineraryList>([]);
  const [image, setImage] = useState("/CommunitiesImage.jpg");

  useEffect(() => {
    itineraryApi
      .getItineraries()
      .then((itins) => itins)
      .then(setRoadtrips);
  }, []);

  const handlehover = (itin: ItineratorSimpleItinerary) => {
    setImage(itin.lead_image?.url || "/CommunitiesImage.jpg");
  };

  return (
    <Flex
      // minH="100svh"
      justifyContent="center"
      flexWrap="wrap"
      bgColor="sage.500"
      py={{ base: 8, lg: 16 }}
      zIndex={1}
    >
      <Flex w={{ base: "60%" }} flexDirection="column" justifyContent="center">
        <Box
          // w={{ base: "100%", lg: "70%" }}
          // pr={{ base: 4, md: 8, lg: 16 }}
          ml={{ base: "40px", md: "104px" }}
          pb={{ base: "24px" }}
        >
          <Heading
            as="h2"
            fontSize={{ base: "6xl", md: "8xl", lg: "6xl" }}
            color="yellow.500"
            mb={2}
          >
            Road Trips
          </Heading>
          <Subheading as="p" fontSize={{ base: "xl" }}>
            Plan your next journey with our themed road trips
          </Subheading>
        </Box>
        <Box
          borderBottom="3px solid"
          borderColor="green.500"
          // w={{ base: "100%", lg: "70%" }}
          mr={{ base: 4, md: 0 }}
        ></Box>
        <Flex
          flexDirection="column"
          justifyContent="space-evenly"
          ml={{ base: "40px", md: "104px" }}
          py={4}
        >
          {itineraries.map((roadtrip) => (
            <Flex key={roadtrip.id} alignItems="center">
              <Heading as={Box} fontSize="2xl" color="yellow.500">
                *
              </Heading>
              <RoadTripLink
                display="flex"
                alignItems="center"
                fontFamily={"heading"}
                href={`/roadtrips/${roadtrip.slug}`}
                fontSize={{ base: "md", md: "2xl" }}
                fontWeight="bold"
                color="white"
                py={2}
                pl="20px"
                pr={10}
                transition="all 0.2s ease"
                sx={{
                  _hover: { pl: 10, pr: 0 },
                }}
                onMouseOver={() => handlehover(roadtrip)}
                gap={4}
              >
                {roadtrip.name}
              </RoadTripLink>
            </Flex>
          ))}
        </Flex>
      </Flex>

      <Flex
        w={{ base: "40%" }}
        maxW="600px"
        alignItems="center"
        p={{ base: 8, lg: 16 }}
        mx="auto"
      >
        <Polaroid
          image={image}
          w={{ base: "142px", lg: "371px" }}
          h={{ base: "164px", lg: "426px" }}
          transform="rotate(-3deg)"
          p={{ base: 2, md: 4 }}
          mb={{ base: 6 }}
        />
      </Flex>
    </Flex>
  );
};

FourthPanel.displayName = "SwiperSlideFourthPanel";
